<template>
  <nut-searchbar v-model="val" @search="$emit('search')" :placeholder="placeholder">
    <template #rightin>
      <Search2 />
    </template>
  </nut-searchbar>
</template>

<script setup>
  import { Search2 } from '@nutui/icons-vue'
  const emit = defineEmits(['update:modelValue', 'search'])

  const props = defineProps({
    modelValue: String,
    placeholder: '请输入姓名/手机号'
  })
  const val = ref(props.modelValue || '')
  watch(val, (val1) => {
    emit('update:modelValue', val1)
  })
</script>
